import defaultStructure from "./default.json";
import hartbergStructure from "./hartberg.json";

const planStructures = {
  default: defaultStructure,
  hartberg: hartbergStructure,
};

export default planStructures;
